import { useContext, useMemo } from 'react';
import { getCookie, removeCookie } from './Cookie';
import parseJSONSGracefully from './parseJSONSGracefully';
import CookieNames from '../constants/CookieNames';
import getUserPreferredLanguage from './i18n/getUserPreferredLanguage';
import UnauthenticatedRouteLanguageContext from './UnauthenticatedRouteLanguageContext';

const DEFAULT_PREFILL_LANGUAGE = 'en';

const useLoginPrefillUser = () => {
    const { setMessageLanguage } = useContext(UnauthenticatedRouteLanguageContext);
    const cookieJson = getCookie(CookieNames.LOGIN_PREFILL_USER);
    const cookieObj = parseJSONSGracefully(cookieJson);
    const cookieObjectWithLanguage = cookieObj
        ? { ...cookieObj, language: DEFAULT_PREFILL_LANGUAGE }
        : null;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const prefillUser = useMemo(() => cookieObjectWithLanguage, []);

    const handlePostLoginSuccess = () => {
        removeCookie(CookieNames.LOGIN_PREFILL_USER);
        setMessageLanguage(getUserPreferredLanguage());
    };

    return [prefillUser, handlePostLoginSuccess];
};

export default useLoginPrefillUser;
